import {
  LifeBuoy,
  Ship,
  Waves,
  Anchor,
  Flame,
  Users,
} from "lucide-react";

export const CONTACT = {
  phone: "604.726.2423",
  phoneRaw: "6047262423",
  email: "info@madpropsmarine.com",
  location: "Ladner, BC",
  tagline: "24/7/365 — We Have Your Back",
};

export const NAV_LINKS = [
  { label: "About", id: "about" },
  { label: "Services", id: "services" },
  { label: "Projects", id: "projects" },
  { label: "Reviews", id: "testimonials" },
  { label: "Community", id: "community" },
  { label: "Contact", id: "footer" },
];

export const SERVICES = [
  {
    id: "emergency",
    title: "Marine Emergency Response",
    desc: "First on scene, any hour, any weather. Rapid response across the Fraser River and Southern BC Coast.",
    icon: LifeBuoy,
    img: "/mpm/work1.jpg",
  },
  {
    id: "towing",
    title: "Towing & Vessel Assist",
    desc: "From disabled pleasure craft to commercial vessels — we get you home safe.",
    icon: Ship,
    img: "/mpm/footer.jpg",
  },
  {
    id: "diving",
    title: "Diving & Salvage",
    desc: "Underwater assessments, recovery and salvage handled by an experienced crew.",
    icon: Waves,
    img: "/mpm/work2.jpg",
  },
  {
    id: "recovery",
    title: "Recovery & Removal",
    desc: "Sinkers, wrecks and derelict vessels lifted, loaded and responsibly disposed of.",
    icon: Anchor,
    img: "/mpm/work8.jpg",
  },
  {
    id: "spill",
    title: "Spill, Fire & Disaster",
    desc: "Containment and disaster response when the water doesn't wait — day or night.",
    icon: Flame,
    img: "/mpm/work5.jpg",
  },
  {
    id: "barge",
    title: "Tug, Barge & Water Taxi",
    desc: "Ramp barge, crew change and private water taxi throughout the channels and coast.",
    icon: Users,
    img: "/mpm/bg.jpg",
  },
];

export const STATS = [
  { value: "24/7", label: "Always On Call" },
  { value: "Commercial", label: "Grade Operations" },
  { value: "Rapid", label: "Emergency Response" },
  { value: "Locally", label: "Owned & Operated" },
];

export const PROJECTS = [
  {
    title: "White Rock Pier Shoreline Clean-Up",
    location: "White Rock, BC",
    img: "/mpm/work6.jpg",
  },
  {
    title: "Ship-Supply & Vessel Assist",
    location: "Salish Sea",
    img: "/mpm/work1.jpg",
  },
  {
    title: "Sunset Salvage & Tow",
    location: "Fraser River",
    img: "/mpm/footer.jpg",
  },
];

export const TESTIMONIALS = [
  {
    name: "Dana R.",
    role: "Vessel Owner",
    text: "Called at 2am with water coming over the transom. Mad Props was on scene fast, calm and got us secured. These are the people you want on the water.",
  },
  {
    name: "Coastal Logistics",
    role: "Commercial Client",
    text: "Reliable crew change and ship-supply runs, every time. Professional, punctual and they genuinely know these waters.",
  },
  {
    name: "M. Chen",
    role: "Private Charter",
    text: "Skipped the ferry line-up entirely. The water taxi to the Gulf Islands felt like a private experience — flexible, safe and a beautiful ride.",
  },
];

export const FUTURE_VISION = [
  { title: "Cinematic Drone Header", desc: "Real aerial footage of the fleet working the Fraser at golden hour." },
  { title: "Interactive Project Gallery", desc: "Filterable case studies of salvage, towing and recovery jobs." },
  { title: "Crew Spotlights", desc: "Meet the people behind the props — authentic team stories." },
  { title: "Before & After Recoveries", desc: "Drag-to-reveal sliders showing dramatic marine turnarounds." },
  { title: "Emergency Call-Out Banner", desc: "A live 'available now' status bar with one-tap dispatch." },
  { title: "Google Reviews Integration", desc: "Pull real 5-star reviews straight from Google Business." },
  { title: "Merch Store", desc: "Drop the Mad Props gear — hoodies, tees and hats." },
  { title: "Careers / Apply", desc: "A crew application page for the next generation of operators." },
];
